import { Attachment as AttachmentDto } from "@accurx/api/clinician-messaging";
import { Attachment } from "domains/concierge/types";

export const mapAttachment = (dto: AttachmentDto): Attachment => {
    return {
        id: dto.id.toString(),
        displayName: dto.displayName,
    };
};
